import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { http } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function VerifyMagic() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "loading", message: "" });
  const nav = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState({ status: "error", message: "This link is missing its token." }); return; }
    http.post("/api/auth/verify", { token })
      .then((res) => {
        login(res.data.token, res.data.user);
        setState({ status: "ok", message: "You're in — loading your guide." });
        setTimeout(() => nav("/guide", { replace: true }), 900);
      })
      .catch((err) => setState({ status: "error", message: err.response?.data?.detail || "This link is invalid or expired." }));
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAF8] flex items-center justify-center px-6">
      <div data-testid="verify-card" className="w-full max-w-md bg-white rounded-2xl border border-[#0E2A47]/8 p-10 shadow-[0_4px_40px_rgba(14,42,71,0.06)] text-center">
        {state.status === "loading" && (
          <><Loader2 className="mx-auto animate-spin text-[#1FB6C9]" size={40} /><p className="mt-6 font-display text-lg text-[#0E2A47]">Verifying your link…</p></>
        )}
        {state.status === "ok" && (
          <><CheckCircle2 className="mx-auto text-[#1FB6C9]" size={40} /><p className="mt-6 font-display text-lg text-[#0E2A47]">{state.message}</p></>
        )}
        {state.status === "error" && (
          <>
            <XCircle className="mx-auto text-red-500" size={40} />
            <p className="mt-6 font-display text-lg text-[#0E2A47]">{state.message}</p>
            <Link to="/login" data-testid="verify-retry-link" className="mt-8 inline-block rounded-full bg-[#1FB6C9] px-6 py-3 text-white font-display font-medium">Request a new link</Link>
          </>
        )}
      </div>
    </div>
  );
}
